var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    { staticClass: "compareModal", attrs: { "md-active": true } },
    [
      _c("md-dialog-title", [_vm._v(_vm._s(_vm.getTitle()))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "plans" },
        [
          _c(
            "div",
            { staticClass: "plan old" },
            [
              _c("div", { staticClass: "header" }, [
                _vm._v(
                  "Current Plan: " + _vm._s(_vm.oldPlan.plan.toUpperCase())
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "plan-price-section" }, [
                _c("div", { staticClass: "plan-price-details" }, [
                  _c(
                    "span",
                    {
                      staticClass: "amount",
                      class: { tl: _vm.site.basePrice.currency === "tl" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.calculateAgentPrice(
                            _vm.oldPlan.agentCount,
                            _vm.oldPlan.plan
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", [
                    _c("i", { staticClass: "slash" }, [_vm._v("/")]),
                    _vm._v(" "),
                    _c("i", { staticClass: "billed-month" }, [
                      _vm._v(_vm._s(_vm.$t("billing.month"))),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("a-divider", [_vm._v(_vm._s(_vm.$t("billing.planDetails")))]),
              _vm._v(" "),
              _c("div", { staticClass: "features" }, [
                _vm.oldPlan.plan === "pro"
                  ? _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", { attrs: { type: "check" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("billing.multiAgentUpTo", {
                                agentCount: _vm.oldPlan.agentCount,
                              })
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", { attrs: { type: "check" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("1 " + _vm._s(_vm.$t("billing.agent"))),
                        ]),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.videoCallUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.audioCallUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.screenSharingUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.fileTransferUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("billing.autoChatAssignerUnlimited"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("billing.multiLanguageTranslationUnlimited")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.detailedReporting"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("billing.fullCustomizationUnlimited"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.oldPlan.plan === "pro"
                  ? _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", { attrs: { type: "check" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("billing.ChatBotUnlimited"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-icon", {
            staticStyle: {
              "margin-left": "10px",
              "font-size": "100px",
              color: "#138412",
            },
            attrs: { type: "arrow-right" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "plan new" },
            [
              _c("div", { staticClass: "header" }, [
                _vm._v("Next Plan: " + _vm._s(_vm.newPlan.plan.toUpperCase())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "plan-price-section" }, [
                _c("div", { staticClass: "plan-price-details" }, [
                  _c(
                    "span",
                    {
                      staticClass: "amount",
                      class: { tl: _vm.site.basePrice.currency === "tl" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.calculateAgentPrice(
                            _vm.newPlan.agentCount,
                            _vm.newPlan.plan
                          )
                        )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", [
                    _c("i", { staticClass: "slash" }, [_vm._v("/")]),
                    _vm._v(" "),
                    _c("i", { staticClass: "billed-month" }, [
                      _vm._v(_vm._s(_vm.$t("billing.month"))),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("a-divider", [_vm._v(_vm._s(_vm.$t("billing.planDetails")))]),
              _vm._v(" "),
              _c("div", { staticClass: "features" }, [
                _vm.newPlan.plan === "pro"
                  ? _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", { attrs: { type: "check" } }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class: {
                              "text-success": _vm.isUpgrading(),
                              "text-danger": _vm.isDowngrading(),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("billing.multiAgentUpTo", {
                                  agentCount: _vm.newPlan.agentCount,
                                })
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", { attrs: { type: "check" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("1 " + _vm._s(_vm.$t("billing.agent"))),
                        ]),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.videoCallUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.audioCallUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.screenSharingUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.fileTransferUnlimited"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("billing.autoChatAssignerUnlimited"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("billing.multiLanguageTranslationUnlimited")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("billing.detailedReporting"))),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "feature" },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("billing.fullCustomizationUnlimited"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.newPlan.plan === "pro"
                  ? _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", {
                          staticClass: "text-success",
                          attrs: { type: "check" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("billing.ChatBotUnlimited"))),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", {
                          staticClass: "text-danger",
                          attrs: { type: "close" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.$t("billing.ChatBotUnlimited"))),
                        ]),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.isCanceling()
                  ? _c(
                      "div",
                      { staticClass: "feature" },
                      [
                        _c("a-icon", {
                          staticClass: "text-danger",
                          attrs: { type: "close" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("billing.multiAgentUpTo", {
                                agentCount: _vm.oldPlan.agentCount,
                              })
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("billing.disagree")))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            { staticClass: "md-primary", on: { click: _vm.onApproved } },
            [_vm._v(_vm._s(_vm.$t("billing.agree")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }